<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'"
              >Số Serial Sim</label
              >
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="msinSearchNumber"
                  :class="rootClass + '__phone-number-input'"
                  type="number"
                  v-on:keyup.enter="getMsin"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;margin-right: 4%">
            <b-button
                :class="rootClass + '__search-voice-sms-data-btn'"
                class="redButton"
                style="margin-left: -30%"
                variant="danger"
                @click="getMsin()"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-voice-sms-data-table'">
            <tr style="height: 3rem">
              <template v-for="(h, i) in historyVoiceSMSDataTable.fields"
              >
                <th
                    :key="h.key"
                    :class="{
                          '--first-th': i === 0,
                          '--last-th':
                            i === historyVoiceSMSDataTable.fields.length - 1,
                        }"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <tr v-if="showErrSearch===false &&msindnResult!='' " style="color:black;">
              <td>1</td>
              <td :class="!isNaN(msindnResult)?'clickableButton':''" @click="searchTTTB">{{ msindnResult }}</td>
            </tr>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "MsinToMsisdn",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu,
  },
  data() {
    return {
      rootClass: "search-crs",
      historyVoiceSMSDataTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "phone", label: "Số thuê bao"},
        ]
      },
      CdrDetail: [],
      regex087: /87\d{7}$/,
      msindnResult: "",
      showErrSearch: true,
    };
  },
  props: {
    msinSearchNumber: String
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    if (this.msinSearchNumber.length > 0) {
      this.getMsin();
    }
  },
  computed: {},
  methods: {
    formatPhoneNum() {
      if (this.msindnResult.startsWith("84")) {
        this.msindnResult = this.msindnResult.substring(2);
        this.msindnResult = "0" + this.msindnResult;
      }
    },
    getMsin() {
      this.showLoading("block")
      useJwt.get('MsisdnFromMsin/' + this.msinSearchNumber).then((response) => {
        this.showLoading("none")
        this.msindnResult = response.data.result.result;
        if (isNaN(this.msindnResult)) {
          this.msindnResult = "Không có thông tin"
        }
        this.showErrSearch = false
        console.log("msisdn", response.data);
      }).catch((error) => {
        this.showLoading("none")
        this.msindnResult = ""
        this.showErrSearch = true
        console.log(error);
      });
    },
    searchTTTB() {
      if (!isNaN(this.msindnResult)) {
        this.formatPhoneNum()
        let tab = {value: "SubscriberInformation", text: "Thông tin thuê bao"}
        this.$emit('searchTTTB', {searchPhoneNumberEmit: this.msindnResult, openTab: tab})
      }

    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
}
</script>

<style lang="scss" scoped>
.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 16px;
    margin-right: 1rem;
    width: 100px;
  }

  &__phone-number-input {
    width: 200px;
    font-size: 16px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    .clickableButton {
      cursor: pointer;
      color: #384DC0;
      text-decoration: underline;
    }

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);

    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
